<template>
  <div class="container">
    <div v-if="editFormConsents">
      <va-input
        style="margin-inline-end:5%"
        :disabled="!canEdit"
        label="Form Title"
        v-model="mutableFields.formTitle"
      ></va-input>

      <va-input
        class="flex md12 xs12"
        label="Form Question"
        type="textarea"
        :disabled="!canEdit"
        v-model="mutableFields.formQuestion"
      ></va-input>

      <va-input
        class="flex md12 xs12"
        label="Comments"
        type="textarea"
        :disabled="!canEdit"
        v-model="mutableFields.comments"
      />
    </div>
    <div class="flex row" v-else>
      <va-select
        style="width:70%; background:inherit "
        label="Select Consent"
        v-model="selectedConsent"
        keyBy="_id"
        :options="consents"
        noOptionsText="All consents are assigned to a form"
        textBy="consentTitle"
      ></va-select>

      <va-button
        :disabled="selectedConsent==undefined || selectedConsent==''"
        @click.prevent="pushConsent"
        style="margin-top:0px; margin-bottom:2%"
        color="success"
      >ADD</va-button>

      <cn-grid @consentRowDeleted="deleteRow" :consents="mutableFields.formConsentDTOS"></cn-grid>
    </div>
  </div>
</template>

<script>
import cnGrid from "../create/FormConsentGrid.vue";
import { mapActions } from "vuex";

export default {
  props: ["form", "fields", "canEdit", "editFormConsents"],
  data() {
    return {
      mutableFields:{
        formTitle: "",
        formQuestion: "",
        formConsentDTOS:[],
        comments:""
      },
    
      selectedConsent: ""
    };
  },
  computed: {
    consents() {
      return this.$store.getters.consents;
    }
  },
  methods: {
    ...mapActions([
      "addConsent",
      "formAddConsent",
      "formRemoveConsent",
      "removeConsent"
    ]),
    pushConsent() {
      if (this.selectedConsent != undefined || this.selectedConsent != "") {
        // this.formAddConsent(this.selectedConsent)
        this.mutableFields.formConsentDTOS.push(this.selectedConsent);
        this.removeConsent(
          this.consents.findIndex(c => c._id === this.selectedConsent._id)
        );
        this.selectedConsent = "";
      }
    },
    deleteRow(consent) {
      const idx = this.mutableFields.formConsentDTOS.findIndex(c => c._id === consent._id);

      this.addConsent(consent);

      this.mutableFields.formConsentDTOS.splice(idx, 1);
    }
  },
  components: {
    cnGrid
  },
  created(){
    this.mutableFields = this.form
  }
};
</script>
